module.exports = "https://www.gc-qa.gnp.com.mx/ed95e3930e65d0fb62257905dd62527c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/seguridad_activo.svg
// module id = 988
// module chunks = 0